import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { accountService } from "@/_services";

function VerifyEmail({ history }) {
  const EmailStatus = {
    Verifying: "Verifying",
    Failed: "Failed",
  };
  const { t } = useTranslation();
  const [emailStatus, setEmailStatus] = useState(EmailStatus.Verifying);

  useEffect(() => {
    const { token } = queryString.parse(location.search);

    // remove token from url to prevent http referer leakage
    history.replace(location.pathname);

    accountService
      .verifyEmail(token)
      .then(() => {
        toast.success(t("account.verificationSuccess"));
        history.push("login");
      })
      .catch(() => {
        setEmailStatus(EmailStatus.Failed);
      });
  }, []);

  function getBody() {
    switch (emailStatus) {
      case EmailStatus.Verifying:
        return <div>{t("account.tokenVerification")}</div>;
      case EmailStatus.Failed:
        return (
          <div>
            {t("account.tokenFailedPart1")}
            <Link to="forgot-password">{t("account.tokenFailedPart2")}</Link>
            {t("account.tokenFailedPart3")}
          </div>
        );
    }
  }

  return (
    <div>
      <h3 className="card-header">{t("account.verifyHeader")}</h3>
      <div className="card-body">{getBody()}</div>
    </div>
  );
}

VerifyEmail.propTypes = {
  history: PropTypes.object,
};

export default VerifyEmail;
